import Swiper, { Pagination, EffectFade, Lazy, Autoplay } from 'swiper';

Swiper.use([Pagination, EffectFade, Lazy, Autoplay]);

const containerEls = document.querySelectorAll('[data-js=carouselboxintro]');
for (let j = containerEls.length - 1; j >= 0; j -= 1) {
	const sliderEl = containerEls[j].querySelector(
		'[data-js=carouselboxintro-carousel]'
	);
	// eslint-disable-next-line no-new
	new Swiper(sliderEl, {
		allowTouchMove: false,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: containerEls[j].querySelector('[data-js=carouselboxintro-nav]'),
			type: 'bullets',
			clickable: true,
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		lazy: { checkInView: true, loadPrevNext: true },
		preloadImages: true,
	});
}
